import React, { useMemo, useState } from 'react'
import { GraniteDataGrid } from '@tecuity/granite-ui/GraniteDataGrid'
import { Accordion } from '@tecuity/granite-ui/Accordion'
import { DetailList } from '@tecuity/granite-ui/DetailList'
import { format } from 'date-fns'
import { useDispatch, shallowEqual, useSelector } from 'react-redux'
import { openSpecificImage } from '../../ImageViewer/ImageViewerActions'
import { checkDLNValid } from '../../BOSearch/BOSearchActions'
import { setErrorToast } from '../../../actions'
import { SET_SELECTED_CONTRACTOR_COMPLAINT } from '../RecordDetailsReducer'

const getDlnLink = (dln, dispatch) => {
  if (dln) {
    return (
      <div
        className={dln.indexOf(',') === -1 ? 'dlnTableLink' : ''}
        tabIndex={dln.indexOf(',') === -1 ? 0 : -1}
        onClick={() => {
          return dln.indexOf(',') === -1
            ? checkDLNValid(
                dln,
                (id) => {
                  dispatch(openSpecificImage(id, dln))
                },
                (dln) => {
                  dispatch(setErrorToast('DLN ' + dln + ' not found'))
                },
              )
            : null
        }}
      >
        {dln}
      </div>
    )
  } else {
    return ''
  }
}

const ContractorComplaintsPanel = ({ setShowDrawer, config }) => {
  const dispatch = useDispatch()
  const { ContractorComplaints = [] } = useSelector(
    (state) => state.record.recordDetails,
    shallowEqual,
  )

  const columns = useMemo(() => {
    const { FieldSettings = {} } = config
    const columnArray = []

    if (FieldSettings && FieldSettings['Complaints'] && FieldSettings['Complaints']['Fields']) {
      const { ComplaintType, ComplaintDate, ComplaintStatus, ImageNum } =
        FieldSettings['Complaints']['Fields']

      if (ComplaintType.IsEnabled)
        columnArray.push({
          field: 'ComplaintType',
          headerName: ComplaintType.DisplayName,
          flex: 1,
          disableColumnMenu: true,
          renderCell: (params) => params.row.ContractorComplaintType.Name,
        })

      if (ComplaintDate.IsEnabled)
        columnArray.push({
          field: 'ComplaintDate',
          headerName: ComplaintDate.DisplayName,
          flex: 1,
          disableColumnMenu: true,
          renderCell: (params) => format(new Date(params.row.ReceivedDate), 'MM/dd/yyyy'),
        })

      if (ComplaintStatus.IsEnabled)
        columnArray.push({
          field: 'ComplaintStatus',
          headerName: ComplaintStatus.DisplayName,
          flex: 1,
          disableColumnMenu: true,
          renderCell: (params) => params.row.ContractorComplaintStatusType.Name,
        })

      if (ImageNum.IsEnabled)
        columnArray.push({
          field: 'ImageNum',
          headerName: ImageNum.DisplayName,
          flex: 1,
          disableColumnMenu: true,
          renderCell: (params) => getDlnLink(params.row.ImageNum, dispatch),
        })
    }

    return columnArray
  }, [config])

  return (
    <React.Fragment>
      <h2>Complaints</h2>
      <GraniteDataGrid
        getRowId={(r) => r.ContractorComplaintId}
        rows={ContractorComplaints}
        columns={columns}
        isRowSelectable={(params) => true}
        rowHeight={60}
        rowBuffer={0}
        onRowClick={(params) => {
          setShowDrawer(true)
          dispatch({
            type: SET_SELECTED_CONTRACTOR_COMPLAINT,
            selectedContractorComplaint: params.row,
          })
        }}
      />
    </React.Fragment>
  )
}

export default ContractorComplaintsPanel

export const ContractorComplaintDetail = ({ config }) => {
  const dispatch = useDispatch()
  const { selectedContractorComplaint } = useSelector((state) => state.record, shallowEqual)
  const [showComplaintDetails, setShowComplaintDetails] = useState(true)
  const [showReasons, setShowReasons] = useState(true)

  const details = useMemo(() => {
    const { FieldSettings = {} } = config
    const array = []
    if (FieldSettings && FieldSettings['Complaints'] && FieldSettings['Complaints']['Fields']) {
      const { ComplaintType, ComplaintDate, ComplaintStatus, ImageNum } =
        FieldSettings['Complaints']['Fields']
      
      if (ComplaintType.IsEnabled) 
        array.push({
          label: ComplaintType.DisplayName,
          value: selectedContractorComplaint.ContractorComplaintType.Name,
        })

      if (ComplaintDate.IsEnabled)
        array.push({
          label: ComplaintDate.DisplayName,
          value: format(new Date(selectedContractorComplaint.ReceivedDate), 'MM/dd/yyyy'),
        })
      
      if (ComplaintStatus.IsEnabled)
        array.push({
          label: ComplaintStatus.DisplayName,
          value: selectedContractorComplaint.ContractorComplaintStatusType.Name,
        })

      if (ImageNum.IsEnabled)
        array.push({
          label: ImageNum.DisplayName,
          value: getDlnLink(selectedContractorComplaint.ImageNum, dispatch),
        })
    }

    return array
  }, [selectedContractorComplaint, config])

  return (
    <div>
      <Accordion
        title="Complaint Details"
        isOpen={showComplaintDetails}
        onChange={() => {
          setShowComplaintDetails((isOpen) => !isOpen)
        }}
      >
        <DetailList details={details} bottomBorder />
      </Accordion>
      <Accordion
        title="Reasons"
        isOpen={showReasons}
        onChange={() => {
          setShowReasons((isOpen) => !isOpen)
        }}
      >
        {(selectedContractorComplaint.ContractorComplaintReasonXrefs || []).map((reason, i) => {
          const type = reason.ContractorComplaintReasonType
          const description = type.Description.includes('[PARAM1]')
            ? type.Description.replace('[PARAM1]', reason.Params)
            : type.Description
          return (
            <div key={`${reason.ContractorComplaintId}-${i}`} className="reason-list">
              <div className="reason-name">{type.Name}:</div>
              <div className="reason-description">{description}</div>
            </div>
          )
        })}
      </Accordion>
    </div>
  )
}
